// Tracks whether the user has completed onboarding. Stored in IndexedDB meta;
// written only post-consent (onboarding is reachable only after acceptance).

import { getMeta, setMeta } from "../store/db";

const KEY = "onboarded_v1";

export async function isOnboarded(): Promise<boolean> {
  return (await getMeta(KEY)) === "1";
}

export async function markOnboarded(): Promise<void> {
  await setMeta(KEY, "1");
}

export async function clearOnboarded(): Promise<void> {
  await setMeta(KEY, "");
}
